import React, { Component } from "react";
import { connect } from "react-redux";
import ApprovalsMiddelware from '.././store/prat_middleware/promotion/approvalsMiddleware';
import "./style/approval.scss";
import { Loader } from ".././components/loader";
import { valueConverter_2, } from '../util-functions/util-funtions'
import ApprovalHistory from '../components/approval-history/ApprovalHistroy';
import OutletMiddleware from "../store/prat_middleware/gt/outletMiddleware";
import ExcludeOutletApprovalPopUp from './ExcludeOutletApprovalPopup';
import CustomToast from '../util-functions/customToast.jsx'

class PromotionApproval extends Component {
  constructor(props) {
    super(props);
    this.state = {
      indexing: [],
      data: undefined,
      draft: undefined,
      expanded: false,
      apiData: undefined,
      openHistory: false,
      comment: '',
      disableApprove: false,
      disableReject: false,
      disableSendback: false,
      excludeApprovalPopupOpen: false
    };
  }

  componentDidMount() {
    let guid = window.location.pathname.substr(19);           //Getting guid from URL

    setTimeout(() => {
      this.props.getExcludeOutletForApprovalScreen(guid);     //Getting excluded outlets
      this.props.get_activity(guid);                          //Getting activity data
      this.props.getApprovalHistory(guid);                    //Getting history
      this.props.getOldPreopso(guid);                         //Getting Old pre-opso data
      this.setState({
        data: this.props.specficActivity
      })
    }, 1000);

  }
  collapse_sku(sku_index, promotion_index) {
    const { apiData } = this.state
    const updated = apiData;
    let current_sku = updated.PreOpso.Promotions[promotion_index].SkuVolumeAnalysis[sku_index]
    if (current_sku.expanded === true) {
      current_sku.expanded = false
    }
    else {
      current_sku.expanded = true
    }
    this.setState({ apiData: updated })

  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.specficActivity !== this.props.specficActivity) {
      if (this.props.specficActivity?.Metadata)
        this.setState({ apiData: this.props.specficActivity })
    }
  }

  handleComment = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleHistorySideBar = () => {
    this.setState({
      openHistory: !this.state.openHistory
    })
  }

  handleOriginalAcivity = () => {
        window.open(`/promotionapproval/${this.props.old_preOpso?.guid}?activity_status=&${this.props.old_preOpso?.activity_code}`, '_blank')
      }

  handleActivitySubmitStatus = (e) => {

    let guidForApproval = window.location.pathname.substr(19);
    if (this.state.comment === '') {
      CustomToast('error', 'Comment Box is Empty!')
    } else {
      const { comment } = this.state
      let status = e.target.name
      if (e.target.name === 'approve') {
        this.setState({ disableApprove: true })
        this.props.postApprovalSubmit(guidForApproval, { status, comment }, this.props.history)
      }
      else if (e.target.name === 'reject') {
        this.setState({ disableReject: true })
        this.props.postApprovalSubmit(guidForApproval, { status, comment }, this.props.history)
      }
      else {
        this.setState({ disableSendback: true })
        this.props.postApprovalSubmit(guidForApproval, { status, comment }, this.props.history)
      }
    }
  }

  hanldePopUpClose = () => {
    this.setState({
      excludeApprovalPopupOpen: !this.state.excludeApprovalPopupOpen
    })
  }

  render() {
    const { apiData } = this.state
    let getDraftStatusURL = window.location.search.substr(17).replace(/%20/g, " ");     // Extracting Status from URL
    let getdraft_status = getDraftStatusURL.substr(0, getDraftStatusURL.indexOf('&'));  // Formatting URL
    return !apiData ?
      <Loader flag={true} /> : (
        <>
          {this.state.openHistory ? <ApprovalHistory isOpen={this.state.openHistory} handleHistorySideBar={this.handleHistorySideBar} approvalHistory={this.props.approvalHistory ? this.props.approvalHistory : []} /> : null}
          <div className='approval_main' >
            <div style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}}>  {/*className='first_section'*/}

              {/* Promotion Detail component Starting */}
              {this.props.specficActivity?.IsExtended ? <div style={{width:'99%',height:'32px',backgroundColor:'#cce5ff',
            display:'flex',justifyContent:'center',alignItems:'center',color:'#1f6dac'}}>
             <img src={require('./gt/images/info-button.svg')} style={{width:'16px',marginRight:'6px'}} alt=''/> This activity is Extended!
              </div>:null }
              <div className='first_section'>
              <div className='upper_divider ' >
                <div className='promo-detail-heading'>  
                  <h2>Promotion Detail</h2>
                  <span className={`draft-status ${(getdraft_status === 'Approved By CDF' || getdraft_status === "Approved By CDFM" || getdraft_status === "Approved By CMD") ? 'status_approved'
                    : (getdraft_status === 'Rejected By CDF' || getdraft_status === 'Rejected By CDFM' || getdraft_status === 'Rejected By CMD') ? 'status_reject' : getdraft_status === 'Submitted By Acom' ? 'status_submit'
                      : (getdraft_status === 'Sent Back By CDF' || getdraft_status === 'Sent Back By CDFM' || getdraft_status === 'Sent Back By CMD') ? 'status-send-back' : void 0}`} style={{ fontSize: '1.1vw' }}>{getdraft_status}</span>
                </div>
                <div className='first_inner_divider' >
                  <ul className='inner_left' style={{ textAlign: 'center', paddingRight: '0.5vw', width: '12vw' }}>
                    <li  > Activity Code </li>
                    {apiData.Metadata?.promotion_detail?.direct_customers ? <li> Customer </li> : null}
                    <li > Category </li>
                    <li > Brand </li>
                    <li > Master Sku </li>
                    <li > Sku </li>
                    <li > Promotion Type </li>
                    <li > Promotion Level </li>
                    {apiData.Metadata?.promotion_detail?.sizes ? <li> Size </li> : null}
                    {apiData.Metadata?.promotion_detail?.promotion_as ? <li > Run Promotion as </li> : null}
                    {apiData.Metadata?.promotion_detail?.sbb_type ? <li > SBB Type </li> : null}
                    <li> Invoice </li>
                    {this.props?.excludeOutletForApprovalScreen.length ? <li > Excluded Outlets </li> : null}
                  </ul>
                  <ul className='inner_left' style={{ marginLeft: '0px', padding: '0px', width: '19vw' }}>
                    <li style={{ padding: '0px', paddingTop: '5px', paddingBottom: '5px' }} >
                      {apiData?.Metadata.promotion_detail.activity_code} 
                      {/* {this.props.specficActivity?.IsExtended ? <span style={{color:'#007fff'}}> ( Extended )</span>:null} */}
                    </li>

                    {apiData.Metadata?.promotion_detail?.direct_customers ?
                      <li style={{ padding: '0px' }} >
                        <ol className='deep_inner_right' style={{ display: 'flex' }}>
                          {apiData?.Metadata?.promotion_detail?.direct_customers.length === 1 ?
                            apiData?.Metadata?.promotion_detail?.direct_customers.map((cust_item,ind) => {
                              return (
                                <li key={ind}>{cust_item ? cust_item.length > 26 ? cust_item.slice(0, 26) + '...' : cust_item : cust_item}</li>
                              )
                            })
                            :
                            <>
                              {apiData?.Metadata?.promotion_detail?.direct_customers.filter((elm, indx) => {    // eslint-disable-line
                                if (indx <= 1) {
                                  return elm
                                }
                              })
                                .map((cust_item) => {
                                  return (
                                    //   cat_ind>2 ? <span style={{textAlign:'left'}} >
                                    //   <li style={{textAlign:'left'}} className='more_items' >+{apiData?.Metadata?.promotion_detail?.categories.length} more</li>
                                    //  </span>:
                                    <li>{cust_item ? cust_item.length > 6 ? cust_item.slice(0, 6) + '...' : cust_item : cust_item}</li>
                                  )
                                })}
                              {apiData?.Metadata?.promotion_detail?.direct_customers.length > 2 ? <span className="more-item">
                                +{apiData?.Metadata?.promotion_detail?.direct_customers.length - 2}more
                                <div className='hidden_items' style={{ top: '16.7vw', height: '100%', width: '37%', right: '40vw' }}>
                                  <ul className='hidden_items_list' >
                                    {apiData?.Metadata?.promotion_detail?.direct_customers.map((elm) => (
                                      <li className='list-li'>{elm}</li>
                                    ))}
                                  </ul>
                                </div>
                              </span> : null}
                            </>
                          }
                          {apiData?.Metadata?.promotion_detail?.direct_customers.length === 0 ? <li style={{ backgroundColor: 'transparent' }}>--</li> : null}
                        </ol>
                      </li>
                      :
                      null
                    }

                    <li style={{ padding: '0px' }} >
                      <ol className='deep_inner_right' style={{ display: 'flex' }}>
                        {apiData?.Metadata?.promotion_detail?.categories.length === 1 ?
                          apiData?.Metadata?.promotion_detail?.categories.map((cat_item, cat_ind) => {
                            return (
                              <li className='tooltip' key={cat_ind}>{cat_item ? cat_item.length > 26 ? cat_item.slice(0, 26) + '...' : cat_item : cat_item}<span className='tooltiptext'>{cat_item}</span></li>
                            )
                          })
                          :
                          <>
                            {apiData?.Metadata?.promotion_detail?.categories.filter((elm, indx) => {    // eslint-disable-line
                              if (indx <= 1) {
                                return elm
                              }
                            })
                              .map((cat_item, cat_ind) => {
                                return (
                                  <li className='tooltip' key={cat_ind}>{cat_item ? cat_item.length > 6 ? cat_item.slice(0, 6) + '...' : cat_item : cat_item}<span className='tooltiptext'>{cat_item}</span></li>
                                )
                              })}
                            {apiData?.Metadata?.promotion_detail?.categories.length > 2 ? <span className="more-item">
                              <span>+{apiData?.Metadata?.promotion_detail?.categories.length - 2}more</span>
                              <div className='hidden_items' style={{ top: '16.7vw', height: '100%', width: '37%', right: '40vw' }}>
                                <ul className='hidden_items_list' >
                                  {apiData?.Metadata?.promotion_detail?.categories.map((elm,ind) => (
                                    <li className='list-li' key={ind}>{elm}</li>
                                  ))}
                                </ul>
                              </div>
                            </span> : null}
                          </>
                        }
                        {apiData?.Metadata?.promotion_detail?.categories.length === 0 ? <li style={{ backgroundColor: 'transparent' }}>--</li> : null}
                      </ol>
                    </li>

                    <li style={{ padding: '0px' }} >
                      <ol className='deep_inner_right' style={{ display: 'flex' }}>
                        {apiData?.Metadata?.promotion_detail?.brands.length === 1 ?
                          apiData?.Metadata?.promotion_detail?.brands.map((br_item, br_ind) => {
                            return (
                              <li className='tooltip' key={br_ind}>{br_item ? br_item.length > 26 ? br_item.slice(0, 26) + '...' : br_item : br_item}<span className='tooltiptext'>{br_item}</span></li>
                            )
                          })
                          :
                          <>
                            {apiData?.Metadata?.promotion_detail?.brands.filter((elm, indx) => {    // eslint-disable-line
                              if (indx <= 1) {
                                return elm
                              }
                            })
                              .map((br_item, br_ind) => {
                                return (
                                  <li className='tooltip' key={br_ind}>{br_item ? br_item.length > 6 ? br_item.slice(0, 6) + '...' : br_item : br_item}<span className='tooltiptext'>{br_item}</span></li>
                                )
                              })}
                            {apiData?.Metadata?.promotion_detail?.brands.length > 2 ? <span className="more-item">
                              <span>+{apiData?.Metadata?.promotion_detail?.brands.length - 2}more</span>
                              <div className='hidden_items' style={{ top: '19.5vw', height: '100%', width: '37%', right: '40vw' }}>
                                <ul className='hidden_items_list' >
                                  {apiData?.Metadata?.promotion_detail?.brands.map((elm,ind) => (
                                    <li className='list-li' key={ind}>{elm}</li>
                                  ))}
                                </ul>
                              </div>
                            </span> : null}
                          </>
                        }
                        {apiData?.Metadata?.promotion_detail?.brands.length === 0 ? <li style={{ backgroundColor: 'transparent' }}>--</li> : null}
                      </ol>
                    </li>

                    <li style={{ padding: '0px' }} >
                      <ol className='deep_inner_right' style={{ display: 'flex' }}>
                        {apiData?.Metadata?.promotion_detail?.master_skus.length === 1 ?
                          apiData?.Metadata?.promotion_detail?.master_skus.map((master_item, master_ind) => {
                            return (
                              <li className='tooltip' key={master_ind}>{master_item ? master_item.length > 26 ? master_item.slice(0, 26) + '...' : master_item : master_item}<span className='tooltiptext'>{master_item}</span></li>
                            )
                          })
                          :
                          <>
                            {apiData?.Metadata?.promotion_detail?.master_skus.filter((elm, indx) => {       // eslint-disable-line
                              if (indx <= 1) {
                                return elm
                              }
                            })
                              .map((master_item, master_ind) => {
                                return (
                                  <li className='tooltip' key={master_ind}>{master_item ? master_item.length > 6 ? master_item.slice(0, 6) + '...' : master_item : master_item}<span className='tooltiptext'>{master_item}</span></li>
                                )
                              })}
                            {apiData?.Metadata?.promotion_detail?.master_skus.length > 2 ? <span className="more-item">
                              <span>+{apiData?.Metadata?.promotion_detail?.master_skus.length - 2}more</span>
                              <div className='hidden_items' style={{ top: '25vw', height: '100%', width: '37%', right: '40vw' }}>
                                <ul className='hidden_items_list' >
                                  {apiData?.Metadata?.promotion_detail?.master_skus.map((elm,ind) => (
                                    <li className='list-li' key={ind}>{elm}</li>
                                  ))}
                                </ul>
                              </div>
                            </span> : null}
                          </>
                        }
                        {apiData?.Metadata?.promotion_detail?.master_skus.length === 0 ? <li style={{ backgroundColor: 'transparent' }}>--</li> : null}
                      </ol>
                    </li>

                    <li style={{ padding: '0px' }} >
                      <ol className='deep_inner_right' style={{ display: 'flex' }} >
                        {apiData?.Metadata?.promotion_detail?.skus.length === 1 ?
                          apiData?.Metadata?.promotion_detail?.skus.map((sku_item, sku_ind) => {
                            return (
                              <li className='tooltip' key={sku_ind}>{sku_item ? sku_item.length > 26 ? sku_item.slice(0, 26) + '...' : sku_item : sku_item}<span className='tooltiptext'>{sku_item}</span></li>
                            )
                          })
                          :
                          <>
                            {apiData?.Metadata?.promotion_detail?.skus.filter((elm, indx) => {       // eslint-disable-line
                              if (indx <= 1) {
                                return elm
                              }
                            })
                              .map((sku_item, sku_ind) => {
                                return (
                                  <li className='tooltip' key={sku_ind}>{sku_item ? sku_item.length > 6 ? sku_item.slice(0, 6) + '...' : sku_item : sku_item}<span className='tooltiptext'>{sku_item}</span></li>
                                )
                              })}
                            {apiData?.Metadata?.promotion_detail?.skus.length > 2 ? <span className="more-item">
                              <span>+{apiData?.Metadata?.promotion_detail?.skus.length - 2}more</span>
                              <div className='hidden_items' style={{ top: '22.2vw', height: '100%', width: '37%', right: '40vw' }}>
                                <ul className='hidden_items_list' >
                                  {apiData?.Metadata?.promotion_detail?.skus.map((elm,ind) => (
                                    <li className='list-li' key={ind}>{elm}</li>
                                  ))}
                                </ul>
                              </div>
                            </span> : null}
                          </>
                        }
                        {apiData?.Metadata?.promotion_detail?.skus.length === 0 ? <li style={{ backgroundColor: 'transparent' }}>--</li> : null}
                      </ol>
                    </li>

                    {apiData.Metadata?.promotion_detail?.promotion_type && <li style={{ padding: '0px', paddingTop: '5px', paddingBottom: '5px' }} >{apiData.Metadata?.promotion_detail?.promotion_type}</li>}
                    {apiData.Metadata?.promotion_detail?.promotion_level && <li style={{ padding: '0px', paddingTop: '5px', paddingBottom: '5px' }} >{apiData.Metadata?.promotion_detail?.promotion_level}</li>}
                    {apiData.Metadata?.promotion_detail?.promotion_as && <li style={{ padding: '0px', paddingTop: '5px', paddingBottom: '5px' }} >{apiData.Metadata?.promotion_detail?.promotion_as}</li>}
                    {apiData.Metadata?.promotion_detail?.sbb_type && <li style={{ padding: '0px', paddingTop: '5px', paddingBottom: '5px' }} >{apiData.Metadata?.promotion_detail?.sbb_type}</li>}
                    <li style={{ padding: '0px', paddingTop: '5px', paddingBottom: '5px' }} >
                      {
                      apiData?.is_invoice_on ? 
                      <span style={{padding:'5px 8px',borderRadius:'2px',backgroundColor:'#3f7fc9',color:'#ffffff'}}>
                        ON
                      </span>
                      :
                      <span style={{padding:'5px 8px',borderRadius:'2px',backgroundColor:'#f1f1f3'}}>
                        OFF
                      </span>
                      }
                    </li>

                    {apiData.Metadata?.promotion_detail?.sizes ?
                      <li style={{ padding: '0px' }} >
                        <ol className='deep_inner_right' style={{ display: 'flex' }}>
                          {apiData?.Metadata?.promotion_detail?.sizes.length === 1 ?
                            apiData?.Metadata?.promotion_detail?.sizes.map((size,ind) => {
                              return (
                                <li className='tooltip' key={ind}>{size ? size.length > 26 ? size.slice(0, 26) + '...' : size : size}<span className='tooltiptext'>{size}</span></li>
                              )
                            })
                            :
                            <>
                              {apiData?.Metadata?.promotion_detail?.sizes.filter((elm, indx) => {       // eslint-disable-line
                                if (indx <= 1) {
                                  return elm
                                }
                              })
                                .map((size,ind) => {
                                  return (
                                    <li className='tooltip' key={ind}>{size ? size.length > 6 ? size.slice(0, 6) + '...' : size : size}<span className='tooltiptext'>{size}</span></li>
                                  )
                                })}
                              {apiData?.Metadata?.promotion_detail?.sizes.length > 2 ? <span className="more-item">
                                +{apiData?.Metadata?.promotion_detail?.sizes.length - 2}more
                                <div className='hidden_items' style={{ top: '16.7vw', height: '100%', width: '37%', right: '40vw' }}>
                                  <ul className='hidden_items_list' >
                                    {apiData?.Metadata?.promotion_detail?.sizes.map((elm,ind) => (
                                      <li className='list-li' key={ind}>{elm}</li>
                                    ))}
                                  </ul>
                                </div>
                              </span> : null}
                            </>
                          }
                          {apiData?.Metadata?.promotion_detail?.sizes.length === 0 ? <li style={{ backgroundColor: 'transparent' }}>--</li> : null}
                        </ol>
                      </li>
                      :
                      null
                    }
                    {this.props?.excludeOutletForApprovalScreen.length ? <li style={{ padding: '0px', paddingTop: '5px', paddingBottom: '5px' }} >
                      <u style={{ color: '#3f7fc9', cursor: 'pointer' }} onClick={this.hanldePopUpClose}> View Excluded Outlets </u> </li> : null}
                  </ul>
                </div>
              </div>
              
              {/* Promotion Detail component Ending */}

              <div className=' right_parent'>
                <div className='__vertical_top' >

                  {/* Geographic Detail component Starting */}

                  <div className='right_upper_section lower_absolute' style={apiData.Metadata?.promotion_detail?.promotion_type_id === '88a78f88-99fd-4095-bddf-30aebe350dcd'
                    ? { margin: '0' } : null}>
                    <h2>Geographic Detail</h2>
                    <div className='first_inner_divider' style={apiData.Metadata?.promotion_detail?.promotion_type_id === '88a78f88-99fd-4095-bddf-30aebe350dcd'
                      ? { justifyContent: 'flex-start' } : null} >
                      <ul className='inner_left' style={{ textAlign: 'center', paddingRight: '0.5vw', width: '12vw' }}>
                        <li > Regions </li>
                        {apiData?.Metadata?.geographic_detail?.areas ? <li > Area </li> : null}
                        {apiData?.Metadata?.geographic_detail?.territories ? <li > Territory </li> : null}
                        <li > Distributor </li>
                      </ul>
                      <ul className='inner_left' style={{ marginLeft: '0px', padding: '0px', width: '19vw' }}>
                        <li style={{ padding: '0px' }} >
                          <ol className='deep_inner_right' style={{ display: 'flex' }}>
                            {apiData?.Metadata?.geographic_detail?.region.length === 1 ?
                              apiData?.Metadata?.geographic_detail?.region.map((region,ind) => {
                                return (
                                  <li className='tooltip' key={ind}>{region ? region.length > 26 ? region.slice(0, 26) + '...' : region : region}<span className='tooltiptext'>{region}</span></li>
                                )
                              })
                              :
                              <>
                                {apiData?.Metadata?.geographic_detail?.region.filter((elm, indx) => {       // eslint-disable-line
                                  if (indx <= 1) {
                                    return elm
                                  }
                                })
                                  .map((region,ind) => {
                                    return (
                                      <li key={ind} className='tooltip'>{region ? region.length > 9 ? region.slice(0, 9) + '...' : region : region}<span className='tooltiptext'>{region}</span></li>
                                    )
                                  })}
                                {apiData?.Metadata?.geographic_detail?.region.length > 2 ? <span className="more-item">
                                  +{apiData?.Metadata?.geographic_detail?.region.length - 2}more
                    <div className='hidden_items' style={apiData.Metadata?.promotion_detail?.promotion_type_id === '88a78f88-99fd-4095-bddf-30aebe350dcd'
                                    ? { top: '7vw', height: '100%', width: '37%', right: '20vw' } : { top: '7vw', height: '100%', width: '37%', right: '0vw' }}>
                                    <ul className='hidden_items_list' >
                                      {apiData?.Metadata?.geographic_detail?.region.map((elm,ind) => (
                                        <li className='list-li' key={ind}>{elm}</li>
                                      ))}
                                    </ul>
                                  </div>
                                </span> : null}
                              </>
                            }
                            {apiData?.Metadata?.geographic_detail?.region.length === 0 ? <li style={{ backgroundColor: 'transparent' }}>--</li> : null}
                          </ol>
                        </li>

                        {apiData?.Metadata?.geographic_detail?.areas && <li style={{ padding: '0px' }} >
                          <ol className='deep_inner_right' style={{ display: 'flex' }}>

                            {apiData?.Metadata?.geographic_detail?.areas.length === 1 ?
                              apiData?.Metadata?.geographic_detail?.areas.map((areas,ind) => {
                                return (
                                  <li className='tooltip' key={ind}>{areas ? areas.length > 26 ? areas.slice(0, 26) + '...' : areas : areas}<span className='tooltiptext'>{areas}</span></li>
                                )
                              })
                              :
                              <>
                                {apiData?.Metadata?.geographic_detail?.areas.filter((elm, indx) => {       // eslint-disable-line
                                  if (indx <= 1) {
                                    return elm
                                  }
                                })
                                  .map((areas,ind) => {
                                    return (
                                      <li className='tooltip' key={ind}>{areas ? areas.length > 9 ? areas.slice(0, 9) + '...' : areas : areas}<span className='tooltiptext'>{areas}</span></li>
                                    )
                                  })}
                                {apiData?.Metadata?.geographic_detail?.areas.length > 2 ? <span className="more-item">
                                  +{apiData?.Metadata?.geographic_detail?.areas.length - 2}more
                    <div className='hidden_items' style={{ top: '10vw', height: '100%', width: '37%', right: '0vw' }}>
                                    <ul className='hidden_items_list' >
                                      {apiData?.Metadata?.geographic_detail?.areas.map((elm,ind) => (
                                        <li className='list-li' key={ind}>{elm}</li>
                                      ))}
                                    </ul>
                                  </div>
                                </span> : null}
                              </>
                            }
                            {apiData?.Metadata?.geographic_detail?.areas.length === 0 ? <li style={{ backgroundColor: 'transparent' }}>--</li> : null}
                          </ol>
                        </li>}

                        {apiData?.Metadata?.geographic_detail?.territories && <li style={{ padding: '0px' }} >
                          <ol className='deep_inner_right' style={{ display: 'flex' }}>
                            {apiData?.Metadata?.geographic_detail?.territories.length === 1 ?
                              apiData?.Metadata?.geographic_detail?.territories.map((territory,ind) => {
                                return (
                                  <li className='tooltip' key={ind}>{territory ? territory.length > 26 ? territory.slice(0, 26) + '...' : territory : territory}<span className='tooltiptext'>{territory}</span></li>
                                )
                              })
                              :
                              <>
                                {apiData?.Metadata?.geographic_detail?.territories.filter((elm, indx) => {       // eslint-disable-line
                                  if (indx <= 1) {
                                    return elm
                                  }
                                })
                                  .map((territory) => {
                                    return (
                                      <li className='tooltip'>{territory ? territory.length > 9 ? territory.slice(0, 9) + '...' : territory : territory}<span className='tooltiptext'>{territory}</span></li>
                                    )
                                  })}
                                {apiData?.Metadata?.geographic_detail?.territories.length > 2 ? <span className="more-item">
                                  +{apiData?.Metadata?.geographic_detail?.territories.length - 2}more
                    <div className='hidden_items' style={{ top: '13vw', height: '100%', width: '37%', right: '0vw' }}>
                                    <ul className='hidden_items_list' >
                                      {apiData?.Metadata?.geographic_detail?.territories.map((elm,ind) => (
                                        <li className='list-li' key={ind}>{elm}</li>
                                      ))}
                                    </ul>
                                  </div>
                                </span> : null}
                              </>
                            }
                            {apiData?.Metadata?.geographic_detail?.territories.length === 0 ? <li style={{ backgroundColor: 'transparent' }}>--</li> : null}
                          </ol>
                        </li>}

                        <li style={{ padding: '0px' }} >
                          <ol className='deep_inner_right' style={{ display: 'flex' }}>
                            {apiData?.Metadata?.geographic_detail?.distributors.length === 1 ?
                              apiData?.Metadata?.geographic_detail?.distributors.map((distributor,ind) => {
                                return (
                                  <li className='tooltip' key={ind}>{distributor ? distributor.length > 30 ? distributor.slice(0, 30) + '...' : distributor : distributor}<span className='tooltiptext'>{distributor}</span></li>
                                )
                              })
                              :
                              <>
                                {apiData?.Metadata?.geographic_detail?.distributors.filter((elm, indx) => {       // eslint-disable-line
                                  if (indx <= 1) {
                                    return elm
                                  }
                                })
                                  .map((distributor,ind) => {
                                    return (
                                      <li className='tooltip' key={ind}>{distributor ? distributor.length > 7 ? distributor.slice(0, 7) + '...' : distributor : distributor}<span className='tooltiptext'>{distributor}</span></li>
                                    )
                                  })}
                                {apiData?.Metadata?.geographic_detail?.distributors.length > 2 ? <span className="more-item">
                                  +{apiData?.Metadata?.geographic_detail?.distributors.length - 2}more
                    <div className='hidden_items' style={apiData.Metadata?.promotion_detail?.promotion_type_id === '88a78f88-99fd-4095-bddf-30aebe350dcd'
                                    ? { top: '10vw', height: '100%', width: '37%', right: '20vw' } : { top: '15.5vw', height: '100%', width: '37%', right: '0vw' }}>
                                    <ul className='hidden_items_list' >
                                      {apiData?.Metadata?.geographic_detail?.distributors.map((elm,ind) => (
                                        <li key={ind} className='list-li'>{elm}</li>
                                      ))}
                                    </ul>
                                  </div>
                                </span> : null}
                              </>
                            }
                            {apiData?.Metadata?.geographic_detail?.distributors.length === 0 ? <li style={{ backgroundColor: 'transparent' }}>--</li> : null}
                          </ol>
                        </li>
                      </ul>

                    </div>

                  </div>

                  {/* Geographic Detail component Ending */}

                  {/* Channel Detail component Starting */}

                  {apiData?.Metadata?.promotion_detail.promotion_type_id === '88a78f88-99fd-4095-bddf-30aebe350dcd' ? null
                    :
                    <div className='right_upper_section ' >
                      <h2>Channel Detail</h2>
                      <div className='first_inner_divider' >
                        <ul className='inner_left' style={{ textAlign: 'center', padding: '0.5vw', width: '12vw', marginBottom: '0px' }}>
                          <li > Master Channel </li>
                          <li > Channel </li>
                          <li > Element </li>
                          <li > Sub Element </li>
                          <li >  </li>
                        </ul>
                        <ul className='inner_left' style={{ marginLeft: '0px', padding: '0px', width: '19vw' }}>
                          <li style={{ padding: '0px' }} >
                            <ol className='deep_inner_right' style={{ display: 'flex' }}>
                              {apiData?.Metadata?.channel_detail?.master_channel.length === 1 ?
                                apiData?.Metadata?.channel_detail?.master_channel.map((master_channel,ind) => {
                                  return (
                                    <li className='tooltip' key={ind}>{master_channel ? master_channel.length > 32 ? master_channel.slice(0, 32) + '...' : master_channel : master_channel}<span className='tooltiptext'>{master_channel}</span></li>
                                  )
                                })
                                :
                                <>
                                  {apiData?.Metadata?.channel_detail?.master_channel.filter((elm, indx) => {       // eslint-disable-line
                                    if (indx <= 1) {
                                      return elm
                                    }
                                  })
                                    .map((master_channel,ind) => {
                                      return (
                                        <li className='tooltip' key={ind}>{master_channel ? master_channel.length > 9 ? master_channel.slice(0, 9) + '...' : master_channel : master_channel}<span className='tooltiptext'>{master_channel}</span></li>
                                      )
                                    })}
                                  {apiData?.Metadata?.channel_detail?.master_channel.length > 2 ? <span className="more-item">
                                    +{apiData?.Metadata?.channel_detail?.master_channel.length - 2}more
                    <div className='hidden_items' style={{ top: '14vw', height: '100%', width: '37%', right: '3vw' }}>
                                      <ul className='hidden_items_list' >
                                        {apiData?.Metadata?.channel_detail?.master_channel.map((elm,ind) => (
                                          <li className='list-li' key={ind}>{elm}</li>
                                        ))}
                                      </ul>
                                    </div>
                                  </span> : null}
                                </>
                              }
                              {apiData?.Metadata?.channel_detail?.master_channel.length === 0 ? <li style={{ backgroundColor: 'transparent' }}>--</li> : null}
                            </ol>
                          </li>

                          <li style={{ padding: '0px' }} >
                            <ol className='deep_inner_right' style={{ display: 'flex' }}>
                              {apiData?.Metadata?.channel_detail?.channel.length === 1 ?
                                apiData?.Metadata?.channel_detail?.channel.map((channel,ind) => {
                                  return (
                                    <li className='tooltip' key={ind}>{channel ? channel.length > 32 ? channel.slice(0, 32) + '...' : channel : channel}<span className='tooltiptext'>{channel}</span></li>
                                  )
                                })
                                :
                                <>
                                  {apiData?.Metadata?.channel_detail?.channel.filter((elm, indx) => {       // eslint-disable-line
                                    if (indx <= 1) {
                                      return elm
                                    }
                                  })
                                    .map((channel,ind) => {
                                      return (
                                        <li key={ind} className='tooltip'>{channel ? channel.length > 9 ? channel.slice(0, 9) + '...' : channel : channel}<span className='tooltiptext'>{channel}</span></li>
                                      )
                                    })}
                                  {apiData?.Metadata?.channel_detail?.channel.length > 2 ? <span className="more-item">
                                    +{apiData?.Metadata?.channel_detail?.channel.length - 2}more
                    <div className='hidden_items' style={{ top: '16.5vw', height: '100%', width: '37%', right: '3vw' }}>
                                      <ul className='hidden_items_list' >
                                        {apiData?.Metadata?.channel_detail?.channel.map((elm,ind) => (
                                          <li className='list-li' key={ind}>{elm}</li>
                                        ))}
                                      </ul>
                                    </div>
                                  </span> : null}
                                </>
                              }
                              {apiData?.Metadata?.channel_detail?.channel.length === 0 ? <li style={{ backgroundColor: 'transparent' }}>--</li> : null}
                            </ol>
                          </li>

                          <li style={{ padding: '0px' }} >
                            <ol className='deep_inner_right' style={{ display: 'flex' }}>
                              {apiData?.Metadata?.channel_detail?.element.length === 1 ?
                                apiData?.Metadata?.channel_detail?.element.map((element,ind) => {
                                  return (
                                    <li key={ind} className='tooltip'>{element ? element.length > 32 ? element.slice(0, 32) + '...' : element : element}<span className='tooltiptext'>{element}</span></li>
                                  )
                                })
                                :
                                <>
                                  {apiData?.Metadata?.channel_detail?.element.filter((elm, indx) => {       // eslint-disable-line
                                    if (indx <= 1) {
                                      return elm
                                    }
                                  })
                                    .map((element,ind) => {
                                      return (
                                        <li key={ind} className='tooltip'>{element ? element.length > 9 ? element.slice(0, 9) + '...' : element : element}<span className='tooltiptext'>{element}</span></li>
                                      )
                                    })}
                                  {apiData?.Metadata?.channel_detail?.element.length > 2 ? <span className="more-item">
                                    +{apiData?.Metadata?.channel_detail?.element.length - 2}more
                    <div className='hidden_items' style={{ top: '19.5vw', height: '100%', width: '37%', right: '3vw' }}>
                                      <ul className='hidden_items_list' >
                                        {apiData?.Metadata?.channel_detail?.element.map((elm,ind) => (
                                          <li key={ind} className='list-li'>{elm}</li>
                                        ))}
                                      </ul>
                                    </div>
                                  </span> : null}
                                </>
                              }
                              {apiData?.Metadata?.channel_detail?.element.length === 0 ? <li style={{ backgroundColor: 'transparent' }}>--</li> : null}
                            </ol>
                          </li>

                          <li style={{ padding: '0px' }} >
                            <ol className='deep_inner_right' style={{ display: 'flex' }}>
                              {apiData?.Metadata?.channel_detail?.sub_element.length === 1 ?
                                apiData?.Metadata?.channel_detail?.sub_element.map((sub_element,ind) => {
                                  return (
                                    <li key={ind} className='tooltip'>{sub_element ? sub_element.length > 32 ? sub_element.slice(0, 32) + '...' : sub_element : sub_element}<span className='tooltiptext'>{sub_element}</span></li>
                                  )
                                })
                                :
                                <>
                                  {apiData?.Metadata?.channel_detail?.sub_element.filter((elm, indx) => {       // eslint-disable-line
                                    if (indx <= 1) {
                                      return elm
                                    }
                                  })
                                    .map((sub_element,ind) => {
                                      return (
                                        <li key={ind} className='tooltip'>{sub_element ? sub_element.length > 9 ? sub_element.slice(0, 9) + '...' : sub_element : sub_element}<span className='tooltiptext'>{sub_element}</span></li>
                                      )
                                    })}
                                  {apiData?.Metadata?.channel_detail?.sub_element.length > 2 ? <span className="more-item">
                                    +{apiData?.Metadata?.channel_detail?.sub_element.length - 2}more
                    <div className='hidden_items' style={{ top: '22vw', height: '100%', width: '37%', right: '3vw' }}>
                                      <ul className='hidden_items_list' >
                                        {apiData?.Metadata?.channel_detail?.sub_element.map((elm,ind) => (
                                          <li key={ind} className='list-li'>{elm}</li>
                                        ))}
                                      </ul>
                                    </div>
                                  </span> : null}
                                </>
                              }
                              {apiData?.Metadata?.channel_detail?.sub_element.length === 0 ? <li style={{ backgroundColor: 'transparent' }}>--</li> : null}
                            </ol>
                          </li>
                        </ul>

                      </div>
                    {/* Channel Detail component Ending */}
                    </div>}
                </div>
                
                {/* Timeline component Starting */}

                <div className='first_lower' >
                  <h2>Timeline</h2>
                  <div className='lower_divider' >
                    <div  >
                      <label>Years & Month</label>
                      <label>{apiData.Metadata?.timeline?.year}</label>
                    </div>
                    <div  >
                      {apiData.Metadata?.timeline?.WeekStart ? <label>Start Week</label> : <label>Start Date</label>}
                      <label>{apiData.Metadata?.timeline?.WeekStart ? apiData.Metadata?.timeline?.WeekStart : apiData.Metadata?.timeline?.DateStart}</label>
                    </div>
                    <div  >
                      {apiData.Metadata?.timeline?.weekEnd ? <label>End Week</label> : <label>End Date</label>}
                      <label>{apiData.Metadata?.timeline?.weekEnd ? apiData.Metadata?.timeline?.weekEnd : apiData.Metadata?.timeline?.DateEnd}</label>
                    </div>
                    <div  >
                      <label>Total Activity Weeks </label>
                      <label>{apiData.Metadata?.timeline?.total_weeks ? apiData.Metadata?.timeline?.total_weeks : "-"}</label>
                    </div>
                    <div  >
                      <label>Weeks In Current Month</label>
                      <label>{apiData.Metadata?.timeline?.current_month_weeks == null ? "-" :
                        apiData.Metadata?.timeline?.current_month_weeks}</label>
                    </div>
                  </div>

                </div>

                {/* Timeline component Ending */}

              </div>
            </div>
            </div>

            <div className='second_section' >
              {/* FOR PROMOTION TYPE GIFTS */}
              {apiData.Metadata?.promotion_detail?.promotion_type_id === 'b0107ffd-5026-4011-bdc6-3bb2e5986332' ?
                null
                :
                <>
                  <div className='second_topRight' >
                    <div className='human' >
                      <span className='human_span' style={{ height: '10px', width: '3px' }} ></span>
                      <label>
                        Human Intervened Values
            </label>
                    </div>
                    <div className='machine' >
                      <span className='machine_span' style={{ height: '10px', width: '3px' }}></span>
                      <label>
                        Machine Generated Values
            </label>
                    </div>
                  </div>

                  <div className='promotion_total' style={{ marginTop: '2.2vw', textAlign: 'center', width: '86.5vw' }} >
                    <div className='total_inner' style={{ textAlign: 'left', width: '86vw' }} >
                      <label style={{ fontSize: '1.2em', paddingLeft: '1vw', textAlign: 'left' }} >PRE-OPSO TOTAL</label>
                      <div className='total_data_section' >
                        <div className='total_divider'>
                          <div className='total_content'   >
                            <label className="sku_keys" > Inc GP </label>
                            <label className='sku_val' >{apiData?.PreOpso?.GpTon ? valueConverter_2(apiData?.PreOpso?.GpTon) : '-'}</label>
                          </div>
                          <div className='total_content'   >
                            <label className="sku_keys" > Baseline </label>
                            <label className='sku_val' >{apiData?.PreOpso?.Baseline ? valueConverter_2(apiData?.PreOpso?.Baseline) : '-'}</label>
                          </div>
                          <div className='total_content'   >
                            <label className="sku_keys" > Total Vol </label>
                            {/* <label className='sku_val' >{apiData?.PreOpso?.TotalVolume?valueConverter_2(apiData?.PreOpso?.TotalVolume):'-'}</label> */}
                            <label className='sku_val' >{apiData?.PreOpso?.TotalVolume ? valueConverter_2(apiData?.PreOpso?.TotalVolume) : '-'}</label>
                          </div>
                          <div className='total_content'   >
                            <label className="sku_keys" > Total Cost </label>
                            <label className='sku_val' >{apiData?.PreOpso?.TotalCost ? valueConverter_2(apiData?.PreOpso?.TotalCost) : '-'}</label>
                          </div>
                          <div className='total_content'   >
                            <label className="sku_keys" > Inc vol </label>
                            <label className='sku_val' >{apiData?.PreOpso?.IncVolume ? valueConverter_2(apiData?.PreOpso?.IncVolume) : '-'}</label>
                          </div>
                          <div className='total_content'   >
                            <label className="sku_keys" > ROI(%) </label>
                            <label className='sku_val' >{apiData?.PreOpso?.Roi ? valueConverter_2(apiData?.PreOpso?.Roi) : '-'}</label>
                          </div>
                        </div>
                        <div className='total_divider'>
                          <div className='total_content'   >
                            <label className="sku_keys" > Incremental Aws </label>
                            <label className='sku_val' >{apiData?.PreOpso?.ActivatedAws ? valueConverter_2(apiData?.PreOpso?.ActivatedAws) : '-'}</label>
                          </div>
                          <div className='total_content'   >
                            <label className="sku_keys" > Total Inc Act Vol </label>
                            <label className='sku_val' >{apiData?.PreOpso?.TotalActivatedVolume ? valueConverter_2(apiData?.PreOpso?.TotalActivatedVolume) : '-'}</label>
                          </div>
                          <div className='total_content'   >
                            <label className="sku_keys" > Activated Weeks </label>
                            <label className='sku_val' >{apiData?.PreOpso?.ActivityDuration ? apiData?.PreOpso?.ActivityDuration : '-'}</label>
                          </div>
                          <div className='total_content'   >
                            <label className="sku_keys" > Post Vol </label>
                            <label className='sku_val' >{apiData?.PreOpso?.PostVolume ? apiData?.PreOpso?.PostVolume : '-'}</label>
                          </div>
                          <div className='total_content'   >
                            <label className="sku_keys" > DNDS Vol </label>
                            <label className='sku_val' >{apiData?.PreOpso?.DndsVolume ? valueConverter_2(apiData?.PreOpso?.DndsVolume) : '-'}</label>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>


                  {apiData?.PreOpso?.Promotions.map((item, index) => {
                    return (
                      <div key={index} className='promotion_main_page' style={{ textAlign: 'center', width: '86.5vw' }}  >

                        {(apiData?.Metadata?.promotion_detail?.promotion_as === 'SBB') || (apiData?.Metadata?.promotion_detail?.promotion_type_id === '137c2b2d-c068-44f6-b1d1-8cd0eda535e5')
                          ?
                          // FOR PROMOTION RUN AS SBB
                          <>
                            <div className='control_panel_upper' >
                              <div className='panel_first approvals_additions' style={{ textAlign: 'left' }} >
                                <label>Project Code </label>
                                <label> {item.ProjectCode} </label>
                              </div>

                              <div className='panel_first approvals_additions' >
                                <label>Budget Restriction </label>
                                <label>
                                  {item.BudgetRestriction ? item.BudgetRestriction : '-'}
                                </label>
                              </div>

                              <div className='panel_first approvals_additions' >
                                <label> ROI%</label>
                                <label>
                                  {item.Roi ? valueConverter_2(item.Roi) : '-'}
                                </label>


                              </div>

                              <div className='panel_first approvals_additions' >
                                <label> Slab Type</label>
                                <label>
                                  {item.SlabType === null ? '-' : item.SlabType}
                                </label>
                              </div>

                              <div className='panel_first approvals_additions' >
                                <label>Detail of Offer</label>
                                <label>{item.DetailOfOffer === null ? '-' : item.DetailOfOffer}</label>
                              </div>

                              <div className='panel_first approvals_additions' >
                                <label> Other Detail</label>
                                <label>  {item.OtherDetails === null ? '-' : item.OtherDetails} </label>
                              </div>

                            </div>

                            {item.Slabs.map(elm => (
                              <div style={{ display: 'flex', width: '37%', justifyContent: 'space-between', fontSize: '1vw', marginBottom: '16px' }}>

                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                  <label style={{ paddingBottom: '10px' }}> Slab From</label>
                                  <label>{elm.SlabFrom === null ? '-' : valueConverter_2(elm.SlabFrom)}</label>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                  <label style={{ paddingBottom: '10px' }}> Slab To</label>
                                  <label> {elm.SlabTo === null ? '-' : valueConverter_2(elm.SlabTo)}</label>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                  <label style={{ paddingBottom: '10px' }}> Norm(%)</label>
                                  <label>  {elm.Norm === null ? '-' : elm.Norm} </label>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                  <label style={{ paddingBottom: '10px' }}> Contribution(%)</label>
                                  <label>  {elm.Contribution === null ? '-' : elm.Contribution} </label>
                                </div>
                              </div>
                            ))}
                          </>
                          :
                          //  FOR TPR
                          <div className='control_panel_upper' >
                            <div className='panel_first approvals_additions' style={{ textAlign: 'left' }} >
                              <label>Project Code </label>
                              <label> {item.ProjectCode} </label>

                              <div className='cp_inner_second' >
                                <label> Apply On</label>
                                <label >  {item.ApplyOn ? item.ApplyOn : '-'} </label>
                              </div>
                            </div>
                            <div className='panel_first approvals_additions' >
                              <label>Budget Restriction </label>
                              <label>
                                {item.BudgetRestriction ? item.BudgetRestriction : '-'}
                              </label>
                              <div className='cp_inner_second' >
                                <label> Apply UOM</label>
                                <label>
                                  {item.ApplyUom === null ? '-' : item.ApplyUom}
                                </label>
                              </div>

                            </div>
                            <div className='panel_first approvals_additions' >
                              <label> Buy Type</label>
                              <label>
                                {item.BuyType === null ? '-' : item.BuyType}
                              </label>

                              <div className='cp_inner_second' >
                                <label> ROI%</label>
                                <label>   {item.Roi ? item.Roi : '-'}</label>
                              </div>
                            </div>
                            <div className='panel_first approvals_additions' >
                              <label> Buy Uom</label>
                              <label>
                                {item.BuyUom === null ? '-' : item.BuyUom}
                              </label>

                              <div className='cp_inner_second' >
                                <label> Detail of Offer</label>
                                <label>   {item.DetailOfOffer ? item.DetailOfOffer : '-'}</label>
                              </div>
                            </div>
                            <div className='panel_first approvals_additions' >
                              <label> Buy From</label>
                              <label>
                                {item.BuyFrom === null ? '-' : item.BuyFrom}
                              </label>


                            </div>
                            <div className='panel_first approvals_additions' >
                              <label> Buy To</label>
                              <label>
                                {item.BuyTo === null ? '-' : item.BuyTo}
                              </label>

                              <div className='cp_inner_second' >
                                <label> Other Detail</label>
                                <label>  {item.OtherDetails === null ? '-' : item.OtherDetails} </label>
                              </div>
                            </div>
                            <div className='panel_first approvals_additions' >
                              <label> Norm Type</label>
                              <label>
                                {item.NormType === null ? '-' : item.NormType}
                              </label>


                            </div>
                            <div className='panel_first approvals_additions' >
                              <label style={{ textAlign: 'center' }}> Norm</label>
                              <label style={{ textAlign: 'center' }}>
                                {item.Norm === null ? '-' : item.Norm}
                              </label>


                            </div>
                          </div>
                        }

                        {item.SkuVolumeAnalysis.map((sku_item, sku_index) => {
                          return (
                            <div className='sku_main' style={{ width: '84.1vw' }} key={sku_index} >
                              <div className='sku_inner_body' >
                                <div className='sku_content_div' style={{ width: '112.4vw' }} >
                                  <label className="sku_keys" >Master Sku Name</label>
                                  <label className='sku_val' >
                                    {sku_item.Description === null ? '-' : sku_item.Description}
                                  </label>
                                </div>
                                <div className='sku_content_div' >
                                  <label className="sku_keys" >Master Sku Code</label>
                                  <label className='sku_val' >
                                    {sku_item.Code === null ? '-' : sku_item.Code}
                                  </label>
                                </div>
                                <div className='sku_content_div' >
                                  <label className="sku_keys" style={{ textAlign: 'center' }} >Gp/Ton </label>
                                  <label className='sku_val' style={{ textAlign: 'center' }} >
                                    {sku_item.GpTon === null ? '-' : valueConverter_2(sku_item.GpTon)}
                                  </label>
                                </div>
                                <div className='sku_content_div' >
                                  <label className="sku_keys" style={{ textAlign: 'center' }}>Aws Baseline </label>
                                  <label className='sku_baseline' >
                                    {sku_item.Baseline === null ? '-' : sku_item.Baseline}
                                    <span style={{ fontSize: '1vw', margin: 'auto 0.2vw', fontWeight: 600 }} >|</span>
                                    <span style={{ color: 'red', }} > {valueConverter_2(sku_item.MachineGeneratedBaseline)} </span>
                                  </label>
                                </div>

                                <div className='sku_content_div' >
                                  <label className="sku_keys" style={{ textAlign: 'center' }}> Total Cost </label>
                                  <label className='sku_baseline' >
                                    {sku_item.TotalCost === null ? '-' : valueConverter_2(sku_item.TotalCost)}
                                    <span style={{ fontSize: '1vw', margin: 'auto 0.2vw', fontWeight: 600 }} >|</span>
                                    <span style={{ color: 'red', }} > {valueConverter_2(sku_item.MachineGeneratedTotalCost)} </span>
                                  </label>
                                </div>
                                <div className='sku_content_div' >
                                  <label className="sku_keys" style={{ textAlign: 'center' }} > Inc Vol </label>
                                  <label className='sku_baseline' >
                                    {sku_item.IncVolume === null ? '-' : valueConverter_2(sku_item.IncVolume)}
                                    <span style={{ fontSize: '1vw', margin: 'auto 0.2vw', fontWeight: 600 }} >|</span>
                                    <span style={{ color: 'red', }} > {valueConverter_2(sku_item.MachineGeneratedIncVolume)} </span>
                                  </label>
                                </div>
                                <div className='sku_content_div'  >
                                  <label className="sku_keys" style={{ textAlign: 'center' }}> Act Duration </label>
                                  <label className='sku_val' style={{ textAlign: 'center' }}> {apiData?.PreOpso?.ActivityDuration} </label>
                                </div>
                                <div className='sku_content_div'  >
                                  <label className="sku_keys" style={{ textAlign: 'center' }}> Pricing </label>
                                  <label className='sku_val' style={{ textAlign: 'center' }}> {sku_item.Pricing?.toFixed(10)} </label>
                                </div>
                                <div className='sku_content_div'  >
                                  <label className="sku_keys" style={{ textAlign: 'center' }}> Grammage </label>
                                  <label className='sku_val' style={{ textAlign: 'center' }}> {sku_item.Grammage?.toFixed(10)} </label>
                                </div>
                                <div className='sku_content_div' >
                                  <label className="sku_keys" style={{ textAlign: 'center' }} > ROI(%) </label>
                                  <label className='sku_baseline' >
                                    {sku_item.Roi === null ? '-' : sku_item.Roi}
                                    <span style={{ fontSize: '1vw', margin: 'auto 0.2vw', fontWeight: 600 }} >|</span>
                                    <span style={{ color: 'red', }} > {valueConverter_2(sku_item.MachineGeneratedRoi)} </span>
                                  </label>
                                </div>
                              </div>

                              {sku_item.expanded === true &&
                                <div className='sku_expand_body content'  >
                                  <div className='sku_expand_div'>
                                    <div className='expanded_content' >
                                      <label className="sku_keys"  > Incremental Aws </label>
                                      <label className='sku_baseline' style={{ textAlign: 'left' }} >
                                        {sku_item.ActivatedAws === null ? '-' : valueConverter_2(sku_item.ActivatedAws)}
                                        <span style={{ fontSize: '1vw', margin: 'auto 0.2vw', fontWeight: 600 }} >|</span>
                                        <span style={{ color: 'red', }} > {valueConverter_2(sku_item.MachineGeneratedActivatedAws)} </span>
                                      </label>
                                    </div>
                                    <div className='expanded_content' >
                                      <label className="sku_keys" >Total Inc Act Vol</label>
                                      <label className='sku_baseline' style={{ textAlign: 'left' }}>
                                        {sku_item.TotalActivatedVolume === null ? '-' : valueConverter_2(sku_item.TotalActivatedVolume)}
                                        <span style={{ fontSize: '1vw', margin: 'auto 0.2vw', fontWeight: 600 }} >|</span>
                                        <span style={{ color: 'red', }} > {valueConverter_2(sku_item.MachineGeneratedTotalActivatedVolume)} </span>
                                      </label>
                                    </div>
                                    <div className='expanded_content' >
                                      <label className="sku_keys" style={{ textAlign: 'center', paddingRight: '1.5vw' }} > Post Aws </label>
                                      <label className='sku_baseline' style={{ textAlign: 'center', paddingRight: '1.5vw' }}>
                                        {sku_item.PostAws === null ? '-' : valueConverter_2(sku_item.PostAws)}
                                        <span style={{ fontSize: '1vw', margin: 'auto 0.2vw', fontWeight: 600 }} >|</span>
                                        <span style={{ color: 'red', }} > {valueConverter_2(sku_item.MachineGeneratedPostAws)} </span>
                                      </label>
                                    </div>
                                    <div className='expanded_content' >
                                      <label className="sku_keys" style={{ paddingLeft: '1.7vw' }} > DNDS Vol </label>
                                      <label className='sku_val' style={{ paddingLeft: '1.7vw' }} >
                                        {sku_item.DndsVolume === null ? '-' : valueConverter_2(sku_item.DndsVolume)}
                                      </label>
                                    </div>

                                  </div>
                                  <div className='sku_expand_div'>
                                    <div className='expanded_content'   >
                                      <label className="sku_keys" >Total Vol</label>
                                      <label className='sku_baseline' style={{ textAlign: 'left' }}>
                                        {sku_item.TotalVolume === null ? '-' : valueConverter_2(sku_item.TotalVolume)}
                                        <span style={{ fontSize: '1vw', margin: 'auto 0.2vw', fontWeight: 600 }} >|</span>
                                        <span style={{ color: 'red', }} > {valueConverter_2(sku_item.MachineGeneratedTotalVolume)} </span>
                                      </label>
                                    </div>

                                    {(apiData?.Metadata?.promotion_detail?.promotion_as === 'SBB') || (apiData?.Metadata?.promotion_detail?.promotion_type_id === '137c2b2d-c068-44f6-b1d1-8cd0eda535e5')
                                      ?
                                      <>
                                        {sku_item.Contributions ? sku_item.Contributions.map((cont, contIndex) => (
                                          <div className='expanded_content' key={contIndex}>
                                            <label className="sku_keys" >Cont {contIndex + 1}</label>
                                            <label className='sku_val' >  {cont} </label>
                                          </div>
                                        ))
                                          :
                                          null
                                        }
                                        <div className='expanded_content' >
                                          <label className="sku_keys" style={{ textAlign: 'left' }}> Norm  </label>
                                          <label className='sku_baseline' >
                                            <label className='sku_val' >  {sku_item.Norm === null ? '-' : sku_item.Norm} </label>
                                          </label>
                                        </div>
                                      </>
                                      :
                                      <>
                                        <div className='expanded_content' >
                                          <label className="sku_keys" > Org Norm </label>
                                          <label className='sku_val' >  {sku_item.OrgNorm === null ? '-' : `${valueConverter_2(sku_item.OrgNorm)}`} </label>
                                        </div>
                                        <div className='expanded_content' >
                                          <label className="sku_keys" style={{ textAlign: 'left' }}> Norm  </label>
                                          <label className='sku_baseline' >
                                            <label className='sku_val' >  {sku_item.Norm === null ? '-' : valueConverter_2(sku_item.Norm)} </label>
                                          </label>
                                        </div>
                                        <div className='expanded_content'  >
                                          <label className="sku_keys" style={{ paddingLeft: '1vw' }}> Norm Delta </label>
                                          <label className='sku_val' style={{ paddingLeft: '1vw' }}>
                                            <label className='sku_val' >  {sku_item.Percentage === null ? '-' : sku_item.Percentage} </label>
                                          </label>
                                        </div>
                                        <div className='expanded_content'  >
                                          <label className="sku_keys" > Norm Type </label>
                                          <label className='sku_baseline' >
                                            <label className='sku_val' >  {sku_item.NormType === null ? '-' : sku_item.NormType} </label>
                                          </label>
                                        </div>
                                      </>
                                    }
                                  </div>

                                </div>
                              }

                              <div className='sku_right_arrow collapsible' >
                                <img src={
                                  sku_item.expanded === true ?
                                    require('./gt/images/arrowUp.svg')
                                    :
                                    require('./gt/images/arrowDown.svg')}
                                  onClick={this.collapse_sku.bind(this, sku_index, index)} alt=''/>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    )
                  })}

                </>
              }
              {/* FOR GIFTS */}
              {apiData.Metadata?.promotion_detail?.promotion_type_id === 'b0107ffd-5026-4011-bdc6-3bb2e5986332' ?
                <>
                  {apiData?.PreOpso?.Promotions.map((item, index) => (

                    <div key={index} className='promotion_main_page' style={{ textAlign: 'center', width: '86.5vw', display: 'flex', justifyContent: 'space-between' }}  >

                      <div className='inner-details-gift'>
                        <span className='first-span'>Project Code</span>
                        <span>{item.ProjectCode}</span>
                      </div>

                      <div className='inner-details-gift'>
                        <span className='first-span'>Detail of Offer</span>
                        <span>{item.DetailOfOffer}</span>
                      </div>

                      <div className='inner-details-gift'>
                        <span className='first-span'>Other Details</span>
                        <span>{item.OtherDetails}</span>
                      </div>

                      <div className='inner-details-gift'>
                        <span className='first-span'>Total Budget</span>
                        <span>{item.TotalBudget}</span>
                      </div>

                      <div className='inner-details-gift'>
                        <span className='first-span'>Total Volume</span>
                        <span>{item.TotalVolume}</span>
                      </div>

                      <div className='inner-details-gift'>
                        <span className='first-span'>Total Cost</span>
                        <span>{valueConverter_2(item.TotalCost)}</span>
                      </div>
                    </div>
                  ))
                  }
                </>
                :
                null
              }

              <div className='lower_section' style={{ marginTop: '3vw', width: '100%' }} >
                <h1 className='__blApproval'>{apiData?.PreOpso?.Detail ? apiData?.PreOpso?.Detail : '--'}</h1>
              </div>
              {this.props.specficActivity?.can_edit ?
                <>
                  <div className='history-comment-heading'>
                    <span>Comments/Reasons</span>
                    <div>
                      <span style={{ color: '#3f7fc9', cursor: 'pointer'}} onClick={this.handleHistorySideBar}><u>View Approval History</u></span>
                      {this.props.old_preOpso?.detail ? null :<span style={{ cursor: 'pointer', marginLeft:'20px'  }} onClick={this.handleOriginalAcivity}><u>View Original Activity</u></span>}
                    </div>
                  </div>
                  <div style={{ textAlign: 'left', marginTop: '1vw', width: '100%' }} >
                    <div className='comment-box-container'>
                      <textarea name='comment' value={this.state.comment} onChange={this.handleComment}></textarea>
                    </div>

                    <div style={{ textAlign: 'right' }} >
                      {(this.state.disableSendback && this.props.performingAction) ? <button className='send_back' name='sendback'>Sending Back.. </button>
                        : <button className='send_back' name='sendback' onClick={(e) => this.handleActivitySubmitStatus(e)}>Send Back </button>}
                      {(this.state.disableReject && this.props.performingAction) ? <button className='__reject' name='reject'>Rejecting.. </button>
                        : 
                        <>
                        {this.props.specficActivity?.IsExtended ?
                          <button className='__reject' name='reject' style={{backgroundColor:'hsl(0,0%,95%)',color:'grey',border: 'hsl(0,0%,95%)'}}>Reject</button>
                          :
                          <button className='__reject' name='reject' onClick={(e) => this.handleActivitySubmitStatus(e)}>Reject </button>
                          }
                        </>
                        }
                      {(this.state.disableApprove && this.props.performingAction) ? <button className='__approve' name='approve'> Approving..</button>
                        : <button className='__approve' name='approve' onClick={(e) => this.handleActivitySubmitStatus(e)}> Approve</button>}
                    </div>

                  </div>
                </>
                :
                <div className='history-comment-cta'>
                  <span style={{ color: '#3f7fc9', cursor: 'pointer' }} onClick={this.handleHistorySideBar}><u>View Approval History</u></span>
                  {this.props.old_preOpso?.detail ? null :<span style={{ cursor: 'pointer', marginLeft:'20px' }} onClick={this.handleOriginalAcivity}><u>View Original Activity</u></span>}
                </div>
              }
            </div>

          </div>

          {/* Excluded Outlet Popup */}
          {this.state.excludeApprovalPopupOpen ? <ExcludeOutletApprovalPopUp isOpen={this.state.excludeApprovalPopupOpen} flagHandle={this.hanldePopUpClose}
            data={this.props.excludeOutletForApprovalScreen ? this.props.excludeOutletForApprovalScreen : []} /> : null}
        </>
      );
  }
}

// redux

const mapStateToProps = state => {
  return {
    specficActivity: state.ApprovalReducer.specficActivity,
    approvalHistory: state.ApprovalReducer.approvalHistory,
    performingAction: state.ApprovalReducer.performingAction,
    excludeOutletForApprovalScreen: state.OutletReducer.excludeOutletForApprovalScreen,
    old_preOpso: state.ApprovalReducer.old_preOpso,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    get_activity: (guid) => {
      return dispatch(ApprovalsMiddelware.get_activity(guid));
    },
    postApprovalSubmit: (guid, data, history) => {
      return dispatch(ApprovalsMiddelware.postApprovalSubmit(guid, data, history));
    },
    getApprovalHistory: (data) => {
      return dispatch(ApprovalsMiddelware.getApprovalHistory(data));
    },
    getExcludeOutletForApprovalScreen: (guid) => {
      return dispatch(OutletMiddleware.getExcludeOutletForApprovalScreen(guid));
    },
    getOldPreopso: (guid) => {
        return dispatch(ApprovalsMiddelware.getOldPreopso(guid));
    }
  }
};
export default connect(mapStateToProps, mapDispatchToProps)(PromotionApproval);
